import { UserBodyDtoRole } from '@api/WhisApi/generated/model/userBodyDtoRole';

export const USER_MANAGEMENT_PAGE_SIZE = 10;
export const USER_MANAGEMENT_SEARCH_DEBOUNCE_MS = 300;
export const USER_MANAGEMENT_SORT_KEY_MAP: Record<string, string> = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  country: 'countryCode',
  organization: 'organization',
  role: 'role',
  createdAt: 'createdAt',
};

export const ADMIN_ROLE_OPTIONS = [
  UserBodyDtoRole.admin,
  UserBodyDtoRole.adminViewOnly,
  UserBodyDtoRole.delegate,
  UserBodyDtoRole.focalPoint,
  UserBodyDtoRole.referenceCenter,
  UserBodyDtoRole.validated,
  UserBodyDtoRole.basic,
];

export const DELEGATE_ROLE_OPTIONS = [
  UserBodyDtoRole.validated,
  UserBodyDtoRole.basic,
];
